import React, { FunctionComponent, useState } from 'react';
import { IoMdResize } from 'react-icons/io';
import OneThirdIcon from '../../../../resources/images/one-third.svg';
import OneHalfIcon from '../../../../resources/images/one-half.svg';
import TwoThirdsIcon from '../../../../resources/images/two-third.svg';
import FullIcon from '../../../../resources/images/three-third.svg';
import { IWidgetSizeDropdownProps } from './types';

const OPTION_ICONS: Record<string, string> = {
  '1/3': OneThirdIcon,
  '1/2': OneHalfIcon,
  '2/3': TwoThirdsIcon,
  full: FullIcon,
};

export const WidgetSizeDropdown: FunctionComponent<IWidgetSizeDropdownProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  const [open, setOpen] = useState(false);

  const selected = value && options.includes(value) ? value : options[0];

  return (
    <div
      className={`widget-size-dropdown${className ? ` ${className}` : ''}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button type="button" className="btn-badge darkGray-bg widget-size-dropdown__toggle">
        <IoMdResize />
      </button>
      {open && (
        <div className="widget-size-dropdown__menu">
          {options.map((option) => (
            <button
              key={option}
              type="button"
              className={`widget-size-dropdown__item${
                option === selected ? ' widget-size-dropdown__item--selected' : ''
              }`}
              onClick={() => {
                if (option !== selected) {
                  onChange(option);
                }
              }}
              title={option}
            >
              {OPTION_ICONS[option] ? <img src={OPTION_ICONS[option]} style={{ height: 20 }} alt="" /> : option}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
